'use client';

import { LogOut, User } from 'lucide-react';
import type { Sesion } from './Login';
import CampanaAvisos from './CampanaAvisos';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

// Iniciales para el avatar (a partir del nombre del usuario).
function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return 'U';
  return (partes[0][0] + (partes[1]?.[0] ?? '')).toUpperCase();
}

// Barra superior: título del sistema + datos del usuario en sesión + salir.
export default function Topbar({
  usuario,
  onLogout,
  onAbrirExpediente,
}: {
  usuario: Sesion;
  onLogout: () => void;
  onAbrirExpediente?: (id: string) => void;
}) {
  return (
    <header className="flex h-16 items-center justify-between border-b bg-card px-6">
      <span className="text-sm font-medium text-muted-foreground">
        Sistema de Gestión Disciplinaria
      </span>

      <div className="flex items-center gap-3">
        <div className="hidden text-right sm:block">
          <div className="text-sm font-medium leading-none">{usuario.nombre}</div>
          <div className="mt-1 text-xs text-muted-foreground">{usuario.rol}</div>
        </div>

        <CampanaAvisos onAbrirExpediente={onAbrirExpediente} />

        <Separator orientation="vertical" className="hidden h-8 sm:block" />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="rounded-full">
              <Avatar className="size-9">
                <AvatarFallback className="bg-primary text-primary-foreground">
                  {iniciales(usuario.nombre)}
                </AvatarFallback>
              </Avatar>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <div className="flex items-center gap-2">
                <User className="size-4" />
                <div>
                  <div className="text-sm font-medium">{usuario.nombre}</div>
                  <div className="text-xs font-normal text-muted-foreground">
                    {usuario.rol}
                  </div>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={onLogout}
              className="text-destructive focus:text-destructive"
            >
              <LogOut className="size-4" />
              Salir
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
